module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-protocol-container"
  }, [_c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          _vm.linkTo(index)
        }
      }
    }, [_c('div', {
      domProps: {
        "textContent": _vm._s(item)
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": require("../assets/image/arrow_icon.png"),
        "alt": ""
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    domProps: {
      "textContent": _vm._s(_vm.right)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.company)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2835091f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutProtocol.vue
// module id = 225
// module chunks = 1